/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Alert, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, Button } from "reactstrap"
import { reportQuestion } from "api/@vp/assess"
import { connect } from "react-redux"
import SweetAlert from 'react-bootstrap-sweetalert'
import { AlertOctagon } from "react-feather"
import classnames from 'classnames'

const OpenField = (props) => {
  const { formRef } = props

  const { reportable, assessmentContext } = props
  const [modalActive, toggleModal] = useState(false)
  const [offenseRadio, toggleRadio] = useState(1)
  const [feedback, updateFeedback] = useState('')
  const [loading, toggleLoading] = useState(false)

  const value = formRef.watch(props.index !== undefined && props !== null
    ? `${props.name}[${props.index}]`
    : props.name, "")

  const onReportSubmit = async () => {
    toggleLoading(true)
    await reportQuestion({
      credentials: assessmentContext.reference,
      target: { teams: props.teams, id: props.id, name: props.name, index: props.index },
      reports: { offenseRadio, feedback }
    })
  }

  return (
    <>
      <FormGroup className={`${props.hidden && 'hidden'}`}>
        <Label for={props.id} className='form-label'>
          {props.title} <span>{!props.required && '(Optional)'}</span>
          {
            reportable &&
            <a className='form-report' onClick={
              () => toggleModal(true)
            }>
              {' '}<AlertOctagon size={15} className="form-report-text" />
              <span className="form-report-text">{ ' report question'}</span>
            </a>
          }
        </Label>
        <Input
          id={props.id}
          type={props.type || 'text'}
          innerRef={formRef.register({
            required: props.required
          })}
          name={
            props.index !== undefined && props !== null
              ? `${props.name}[${props.index}]`
              : props.name
          }
          placeholder={
            props.index !== undefined && props !== null
              ? 'Enter text here'
              : props.placeholders[props.name]
          }
          invalid={
            props.index !== undefined && props !== null
              ? (formRef.errors && (formRef.errors[props.name] && (formRef.errors[props.name][props.index] !== undefined)))
              : (formRef.errors && (formRef.errors[props.name] !== undefined))
          }
          onKeyPress={(e) => {
            if (e.key === "Enter" && !e.shiftKey) e.stopPropagation()
          }}
          disabled={props.disabled}
          className={reportable && "mt-1"}
          maxLength={props.maxLength}
          rows='3'
        />
        {
          props.counter &&
          <span
            className={classnames('textarea-counter-value float-right', {
              'bg-danger': value.length > props.maxLength
            })}>
            {`${value.length}/${props.maxLength}`}
          </span>  
        }
      </FormGroup>

      {
        reportable &&
        <Modal className="modal-form modal-dialog-centered" isOpen={modalActive} toggle={() => toggleModal(false)}>
          <ModalHeader toggle={() => toggleModal(false)}>Report This Question: {props.title}</ModalHeader>
          <ModalBody className="px-2">
            <Label className='form-label'>Please let us know:</Label>
            <Alert onClick={() => toggleRadio(1)} color={offenseRadio === 1 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>This question is not relevant</span></div>
            </Alert>
            <Alert onClick={() => toggleRadio(2)} color={offenseRadio === 2 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>This question is inappropriate</span></div>
            </Alert>
            <Alert onClick={() => toggleRadio(3)} color={offenseRadio === 3 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>Others</span></div>
            </Alert>
            <Label for={`report-${props.id}`} className='form-label'>Feedback:</Label>
            <Input id={`report-${props.id}`} type={'text'} onChange={(e) => updateFeedback(e.target.value)} />
            <Button className="m-0 mt-1 w-100" color="primary" onClick={onReportSubmit}>Submit</Button>
          </ModalBody>
          {loading &&
            <SweetAlert info showConfirm onConfirm={() => { toggleLoading(false); toggleModal(false); }}>
              <div className="sweet-alert-text">Thank you for your feedback, we will get back to you!</div>
            </SweetAlert>
          }
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => {
  return {
    assessmentContext: state.platform.vp.assessmentContext || state.platform.vt.assessmentContext,
  }
}

export default connect(mapStateToProps)(OpenField)
